<template>
  <button 
    :style="style" 
    :disabled="disabled"
    @click="$emit('click', $event)"
  >
    <span v-if="disabled">
      Enviando...
    </span>
    <span v-else>
      <slot/>
    </span>
  </button>
</template>

<script>
import colors from '@/services/colors'

export default {
  name: 'Button',
  props: {
    color: {
      type: String,
      default: colors.purple
    },
    gray: {
      type: Boolean,
      default: false
    },
    blue: {
      type: Boolean,
      default: false
    },
    bradesco: {
      type: Boolean,
      default: false
    },
    big: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: false
    },
    minWidth: {
      type: Number
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    style() {

      let style = {
        borderRadius:    this.big ? '50px'  : '50px',
        height:          this.big ? '57px'  : '41px',
        fontSize:        this.big ? '25px'  : '18px',
        minWidth:        this.minWidth ? `${this.minWidth}px` : (this.big ? '290px' : '145px'),
        backgroundColor: this.border ? 'transparent' : this.color,
        borderColor:     this.blue ? colors.blue : this.color,
        color:           this.blue ? colors.blue : '#fff',
      }

      let disabledColor = {
        backgroundColor: '#d2d2d2',
        borderColor:     '#d2d2d2',
      }

      let bradescoColor = {
        backgroundColor: '#fff',
        borderColor:     '#fff',
        color:           colors.red,
      }

      if(this.disabled) style = {...style, ...disabledColor}
      if(this.bradesco) style = {...style, ...bradescoColor}
      if(this.gray) style = {...style, ...disabledColor}

      return style

    }
  }
}
</script>

<style lang="scss" scoped>
button {
  box-sizing: border-box;
  font-weight: 600;
  border: 0;
  border-style: solid;
  border-width: 2px;
}
</style>
